import { getProductWithMeasurementsRequestBody } from '../../../../helpers/getProductWithMeasurementsRequestBody';
import {
  ProductBuilderMachineContext,
  ProductWithMeasurementsResponse,
} from '../../../../types';

export type GetProductWithMeasurementsLive = (
  context: ProductBuilderMachineContext,
) => Promise<ProductWithMeasurementsResponse>;

const url = process.env.REACT_APP_DYNAMIC_PRICING_URL;

export const getProductWithMeasurementsLive: GetProductWithMeasurementsLive = async context => {
  const requestBody = getProductWithMeasurementsRequestBody(context);
  const requestNumber = requestBody.data.length;

  const firstRequestBody = { data: requestBody.data[0] };

  const firstRequest = await fetch(url || '/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: requestBody ? JSON.stringify(firstRequestBody) : '',
  });

  let secondRequest;

  if (requestNumber === 2) {
    const secondRequestBody = { data: requestBody.data[1] };
    secondRequest = await fetch(url || '/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: requestBody ? JSON.stringify(secondRequestBody) : '',
    });
  }

  const response = firstRequest;
  if (requestNumber === 1 && response.ok === true) {
    return await response.json();
  } else if (
    requestNumber === 2 &&
    response.ok === true &&
    secondRequest &&
    secondRequest.ok === true
  ) {
    const firstResponse = await response.json();
    const secondResponse = await secondRequest.json();
    let completeData = {
      ...firstResponse,
    };
    for (let i = 0; i < secondResponse.data.length; i++) {
      completeData.data.push(secondResponse.data[i]);
    }
    return completeData;
  } else {
    throw new Error(response.statusText);
  }
};
